import { CREATE_ROUTE } from '../actions/routes';

export const initialState = {
  inflight: false,
  byId: {},
  allIds: [],
  lastUpdated: null,
};

const routesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ROUTE:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.route.id]: { ...action.route },
        },
      };
    default:
      return state;
  }
};

export default routesReducer;
